let origin;
export class Point {
  constructor(obj) {
    this.x = obj.x
    this.y = obj.y
    this.z = obj.z
  }

  add(point) {
    let p = new Point(this)
    p.x += point.x
    p.y += point.y
    p.z += point.z
    return p
  }

  delta(point) {
    let p = new Point(this)
    p.x -= point.x
    p.y -= point.y
    p.z -= point.z
    return p
  }

  multiply(num) {
    let p = new Point(this)
    p.x *= num
    p.y *= num
    p.z *= num
    return p
  }

  static dist(p1, p2) {
    return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y))
  }

  static distXZ(p1, p2) {
    return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.z - p2.z) * (p1.z - p2.z))
  }

  static dist3D(p1, p2) {
    return Math.sqrt(
      (p1.x - p2.x) * (p1.x - p2.x)
      + (p1.y - p2.y) * (p1.y - p2.y)
      + (p1.z - p2.z) * (p1.z - p2.z)
    )
  }

  static getOrigin() {
    if (!origin) {
      origin = new Point({x:0,y:0,z:0})
    }
    return origin
  }
}



// WEBPACK FOOTER //
// ./src/components/Point.js